import Button, {StyleType} from "patient-ping-remedy/packages/button";
import Modal from "patient-ping-remedy/packages/modal";
import React from "react";
import {
  StandardSemiBoldTypography,
  StandardTypography
} from "patient-ping-remedy/packages/typography";

interface Props {
    close: () => void;
    setConfirmRemoveModalOpen: () => void;
    name: string;
    tableName: string;
}

export default function ConfirmDeleteModal(props: Props) {
  const buttons = [
    <Button
      key="cancel"
      onClick={props.close}
      styleType={StyleType.TERTIARY}
    >
      Cancel
    </Button>,
    <Button
      key="remove"
      onClick={() => {
        props.setConfirmRemoveModalOpen();
        props.close();
      }}
    >
      Remove
    </Button>
  ];
  return (
    <>
      <Modal
        headerText={`Remove ${props.name}`}
        hideModal={props.close}
        buttons={buttons}>
        <StandardTypography>
          {"Are you sure you want to remove "}
          <StandardSemiBoldTypography>{props.name}</StandardSemiBoldTypography>
          {" from "}
          <StandardSemiBoldTypography>{props.tableName}</StandardSemiBoldTypography>
          {"?"}
        </StandardTypography>
      </Modal>
    </>
  );
}
